import request from '@/lib/request'
import { buildWithholdingAuthRedirectUrl } from '@/common/withholdingAuth';


/***
 * 根据订单号查询支付状态和详细信息
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function queryPaymentInfo(params = {}) {
  return request.post('/api/v1/rental/payment/query', params);
}

/***
 * 发起 COD Service Fee 支付，返回支付地址或二维码内容
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function createCodShippingFeePayment(params = {}) {
  return request.post('/api/v1/rental/payment/cod-shipping-fee', {
    orderId: params.orderId || '',
    returnUrl: params.returnUrl || '',
    payChannel: params.payChannel || ''
  });
}

export function createStorePayment(params = {}) {
  return request.post('/api/v1/rental/payment/store', {
    orderId: params.orderId || '',
    returnUrl: params.returnUrl || '',
    payChannel: params.payChannel || ''
  });
}

/**
 * 查询指定订单最新的待支付单
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function queryLatestPendingPayment(params = {}) {
  return request.post('/api/v1/rental/payment/latest-pending', {
    orderId: params.orderId || '',
    payScene: params.payScene || ''
  });
}


/***
 * 发起 DANA 授权代扣，返回 PayCools 授权链接
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function applyDirectDebit(params = {}) {
  return request.post('/api/v1/rental/paycools/direct-debit/apply', {
    channelCode: params.channelCode || 'ID_DANA_DIRECT_DEBIT',
    terminalType: 'WEB',
    osType: '',
    redirectUrl: params.redirectUrl || buildWithholdingAuthRedirectUrl(params.route)
  });
}

/***
 * 查询 DANA 授权代扣账户列表
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function queryDirectDebitList() {
  return request.get('/api/v1/rental/paycools/direct-debit/list');
}

/***
 * 取消 DANA 授权代扣账户
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function cancelDirectDebit(params = {}) {
  return request.post('/api/v1/rental/paycools/direct-debit/cancel', {
    id: params.id || ''
  });
}
